import { render, staticRenderFns } from "./Accepted.vue?vue&type=template&id=6dae1e2c"
import script from "./Accepted.vue?vue&type=script&lang=js"
export * from "./Accepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports